import { URI } from '@/config/config';

export default async ({ rootState }, payload) => {
  const token = rootState['DATA-ACCESS'].tokenAuth;

  const opts = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'user-token': rootState['DATA-ACCESS'].userToken,
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload)
  };
  const path = new URL(`${URI}control-panel/consumer/suspension`);

  try {
    const response = await fetch(path, opts);
    const jsonResult = await response.json();
  
    return jsonResult.data;
  } catch (error) {
    return Promise.reject(error);
  }
};
